(function(){

	angular
		.module('ngmvac')
		.controller('AutoPackController', AutoPackController);

	AutoPackController.$inject = ['$scope', 'AutoFactory', 'ReservationFactory', 'Cart'];

	function AutoPackController($scope, AutoFactory, ReservationFactory, Cart) {
		var vm = this;

		vm.cart = Cart;
		vm.cart.config.editable = true;
		vm.total = 0;
		vm.step = 3;
		vm.autos = [];
		vm.cotizador = {};
		vm.loadFlota = true;

		vm.places = ['Aeropuerto', 'Centro'];
		vm.hours = [];

		for (var hr = 0; hr < 24; hr++) {
			vm.hours.push( hr + ':00');
			vm.hours.push( hr + ':30');
		}


		$scope.$on('cartLoaded', function(event, args) {
			vm.total = args.total;
			console.log(args);
		});

		$scope.$on('itemCartDeleted', function(event, args) {
			vm.total = args.total;
			console.log(args);
			swal(args.item[0].name + ' ha sido eliminado.', '', 'error');
		});

		vm.cart.init();

		AutoFactory.setTipo(vm.step);
		
		// Llamada a las factorias
		AutoFactory.get({params : {}})
			.then(function (response) {
				var flota = response.data.flota;
				vm.loadFlota = false;
				
				angular.forEach(flota, function (categoria) {
					vm.autos.push(categoria);
				});

				vm.cotizador = response.data.cotizador;
			});

		vm.addAuto = function (clickEvent, auto) {
			var DOMElement = angular.element(clickEvent.target);
			
			DOMElement
				.append(' <i class="fa fa-spin fa-spinner"></i>')
				.prop('disabled', true);;

			var startDateCP = vm.cotizador.fhInicio;
			var endDateCP = vm.cotizador.fhFin;

			var autoAdapter = {
				type: 'auto',
				name: auto.nombreAuto,
				description: auto.descripccion,
				caminoImagen: auto.imagenReal,
				proveedor: auto.id_proveedor,
				categoryCode: auto.id_categoria,
				categoryName: auto.categoria,
				startDate: startDateCP,
				endDate: endDateCP,
				idDatosDirectorioAbrir: auto.id_datos_directorio_abrir,//zoneName: '',
				idDatosDirectorioCerrar: auto.id_datos_directorio_cerrar, //destinationName: '',
				images: [{
					path: auto.imagen,
					imageTypeCode: 'GEN'
				}],
				imagesProveedor: [{
					path: auto.imagenProveedor
				}],
				price: parseFloat(auto.tarifaPublica) * parseInt(auto.totalDiasReservacion),
				content: [{
					price: parseFloat(auto.tarifaPublica),
					net: auto.tarifaNeta,
					adults: auto.cant_pasajeros,
					amount: 1
				}],
				loaded: false,
				cotizador: angular.copy(vm.cotizador)
			};

			vm.cart.add(autoAdapter, function (item) {
				DOMElement
                    .prop('disabled', false)
                    .find('i')
                    .remove();
                swal(item.name + " agregado", "", "success");
			});		
		}

		vm.search = function () {
			vm.loadFlota = true;
			vm.autos.length = 0;
			AutoFactory.get({params: vm.cotizador})
				.then(function (response) {
					vm.loadFlota = false;
					var flota = response.data.flota;
				
					angular.forEach(flota, function (categoria) {
						vm.autos.push(categoria);
					});
				});
		}

	}

})();